import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiTabs, SuiTab } from '@splashthat/sui';
import Form from 'common/icons/Form';
import PaintBucket from 'common/icons/PaintBucket';

import { QUESTIONS, STYLE } from '../../constants/sidebarTabValues';

import { setActiveSidebarTab } from '../../actions';

import { getFormId, getActiveSidebarTab } from '../../selectors';

const QUESTIONS_LABEL = 'Content';
const QUESTIONS_TITLE = 'Edit form questions';
const STYLE_LABEL = 'Style';
const STYLE_TITLE = 'Edit form style';
const baseClassName = 'FormEditorLayoutHeader';

const FormEditorLayoutHeader = (props) => (
    <SuiContainer className={baseClassName} variation="flex-horizontal-centered flex-inherit">
        <SuiTabs
            className={`${baseClassName}__tabs-container`}
            onChange={(event, value) => props.onActiveSidebarTabChange(value)}
            value={props.activeSidebarTab}
            size="small"
            variation=""
        >
            {[
                <SuiTab
                    key={QUESTIONS}
                    value={QUESTIONS}
                    label={QUESTIONS_LABEL}
                    iconBefore={Form}
                    iconDirection="column"
                    title={QUESTIONS_TITLE}
                    data-qa={`${baseClassName}__questions`}
                    disabled={!props.canEditForm}
                />,
                props.stylingEnabled && (
                    <SuiTab
                        key={STYLE}
                        value={STYLE}
                        label={STYLE_LABEL}
                        iconBefore={PaintBucket}
                        iconDirection="column"
                        title={STYLE_TITLE}
                        data-qa={`${baseClassName}__style`}
                        disabled={!props.canEditForm}
                    />
                ),
            ].filter(Boolean)}
        </SuiTabs>
    </SuiContainer>
);

FormEditorLayoutHeader.propTypes = {
    activeSidebarTab: PropTypes.oneOf([QUESTIONS, STYLE, null]).isRequired,
    stylingEnabled: PropTypes.bool.isRequired,
    onActiveSidebarTabChange: PropTypes.func.isRequired,
    canEditForm: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    return {
        activeSidebarTab: formId ? getActiveSidebarTab(state) : null,
    };
};

const mapDispatchToProps = {
    onActiveSidebarTabChange: setActiveSidebarTab,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormEditorLayoutHeader);
